import errorBoundary from './components';

export default errorBoundary;
